
import { PaymentHeader } from "./PaymentHeader";
import { PaymentsList } from "./PaymentsList";
import { PaymentPromotions } from "./PaymentPromotions";
import { usePolicyData } from "@/hooks/usePolicyData";
import { Policy } from "@/components/admin/contact-details/sections/policy/types";
import { ManagePayments } from "@/components/admin/contact/ManagePayments";

interface PaymentsContainerProps {
  userId: string;
}

export const PaymentsContainer = ({ userId }: PaymentsContainerProps) => {
  const { policies, loading, error } = usePolicyData(userId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading policies</div>;
  }

  return (
    <div className="space-y-6">
      <PaymentHeader userName="User" />
      <ManagePayments contactId={userId} />
      <PaymentPromotions />
    </div>
  );
};
